import { filterService } from '@services/filterService';

let initialized = false;

let brandValues: string[] = [];
let bodyTypeValues: string[] = [];
let fuelTypeValues: string[] = [];
let transmissionValues: string[] = [];
let budgetValues: string[] = [];
let seatingCapacityValues: string[] = [];

export const initFilterCache = async () => {
  if (initialized) return;

  const data = await filterService.getFilters();

  if (data) {
    brandValues = data.brand_model.map((b: any) => b.brand_value?.toLowerCase());
    bodyTypeValues = data.body_type.map((b: any) => b.value.toLowerCase());
    fuelTypeValues = data.fuel_type.map((f: any) => f.value.toLowerCase());
    transmissionValues = data.transmission.map((t: any) => t.value.toLowerCase());
    budgetValues = data.budget_range.map((b: any) => b.value.toLowerCase());
    seatingCapacityValues = data.seat_capacity.map((s: any) => s.value.toLowerCase());

    initialized = true;
  }
};

// Auto-initialize when module is imported
initFilterCache().catch(console.error);

export const getFilterValues = () => {
  if (!initialized) {
    console.warn('Filter cache not yet initialized, returning empty arrays');
  }
  
  return {
    brandValues,
    bodyTypeValues,
    fuelTypeValues,
    transmissionValues,
    budgetValues,
    seatingCapacityValues
  };
};
